export function isSuggestionStreetAddress(suggestionText: string): boolean {
  const parts = suggestionText.split(',');
  if (parts.length < 4) {
    return false;
  }
  return true;
}
